import {
  KEY_SETTINGS_ENABLED_ON_TABS,
  KEY_SETTINGS_ENABLED_ON_TABS_TIMEOUT,
  KEY_SHOWN_SCENARIOS, KEY_WIDGET_LAST_CHANGES
} from '~/constants';
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from '~/helpers/storage';
import { clickstreamLogger } from '~/logging';
import settings from '~/utils/Settings';

const defaultTimeout = 10800000;

const getTabsTimeout = () => {
  try {
    const timeoutFromSettings = settings.get(
      KEY_SETTINGS_ENABLED_ON_TABS_TIMEOUT
    );

    return timeoutFromSettings ? timeoutFromSettings * 1000 : defaultTimeout;
  } catch (e) {
    clickstreamLogger.error(e);

    return defaultTimeout;
  }
};

const getPreviousTime = (code: string) => {
  try {
    // @ts-ignore
    return getFromLocalStorage(KEY_SHOWN_SCENARIOS, code)?.time || 0;
  } catch (e) {
    return 0;
  }
};

/**
 *
 * @param code
 *
 * return boolean true - таймаут актуален, false - время просрочено.
 */
export const tabsTimeoutIsExpired = (code: string) => {
  try {
    return Date.now() - getPreviousTime(code) > getTabsTimeout();
  } catch (e) {
    console.log({ e });

    return false;
  }
};

export const getEnabledOnTabs = () =>
  settings.get(KEY_SETTINGS_ENABLED_ON_TABS);
